import { getMentionOnSelectItem } from '@platejs/mention';
import { MENTION_PREFIX } from './constants';
import type { MentionUser } from '../../types/mention';

// Canonical Plate mention-select handler. It inserts the `mention` node, then
// runs `editor.tf.move({ unit: 'offset' })` to step the caret PAST the inline
// void chip, and (because the plugin is configured with insertSpaceAfterMention)
// appends a trailing space. Building it once at module scope is fine — it closes
// over no editor state; the editor is passed in per call.
//
// RECUR-26761 AC4: the previous code called `editor.tf.insert.mention(...)`
// directly and omitted the caret-advance, leaving the caret to the LEFT of the
// inserted tag. Delegating to the library handler fixes the caret placement.
const onSelectMention = getMentionOnSelectItem();

/**
 * Insert a mention chip for `user` at the current selection and leave the caret
 * AFTER it (plus the trailing space). `search` is the text the user typed after
 * the `@`, forwarded so the plugin can record/clean it up.
 */
export function insertMentionForUser(editor: any, user: MentionUser, search = ''): void {
    const label = MENTION_PREFIX + (user.name || user.emailId || '');
    onSelectMention(editor, { key: user.userId, text: label }, search);
}
